import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'core/api/api.service';
import { AppInfoService } from 'core/app-info/app-info.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-delivery-email',
  templateUrl: './delivery-email.component.html',
  styleUrls: ['./delivery-email.component.scss'],
  standalone: false
})

export class DeliveryEmailComponent implements OnInit {
  selectForm;
  private urlDelivery = '/api/email/leads/delivery';
  element;
  appStrings = this.appInfoService.appStrings;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<DeliveryEmailComponent>,
    private formBuilder: UntypedFormBuilder,
    private appInfoService: AppInfoService,
    public apiService: ApiService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.element = data.record;
  }

  ngOnInit() {
    this.selectForm = this.formBuilder.group({});
  }

  edit() {
    this.router.navigate(['leads/delivery-location/edit/', this.element.leadId]);
    this.close();
  }

  close(result?): void {
    this.dialogRef.close(result);
  }

  sendDeliveryEmailDetails() {
    this.loading = true;
    this.apiService.post(this.urlDelivery, { id: this.element.leadId })
      .pipe(finalize(() => this.loading = false))
      .subscribe(result => this.close(result));
  }
}
